/**
 * Resolução de URLs por plataforma (web / Android / iOS)
 *
 * No emulador Android, `localhost` e `127.0.0.1` apontam para o próprio
 * emulador, não para a máquina de desenvolvimento — que é alcançada por
 * `10.0.2.2`. Em dispositivo físico é necessário o IP da rede local, definido
 * pelas variáveis `*_NATIVE`.
 */

const ANDROID_HOST_LOOPBACK = '10.0.2.2'

export function getPlatform() {
  if (typeof window === 'undefined' || !window.Capacitor) return 'web'
  return typeof window.Capacitor.getPlatform === 'function'
    ? window.Capacitor.getPlatform()
    : 'web'
}

export function isNativePlatform() {
  return ['android', 'ios'].includes(getPlatform())
}

export function rewriteLoopbackForNative(url) {
  if (!url || getPlatform() !== 'android') return url
  return url.replace(/\/\/(localhost|127\.0\.0\.1)(?=[:/?#]|$)/, `//${ANDROID_HOST_LOOPBACK}`)
}

export function getApiBaseUrl() {
  const fromEnv = isNativePlatform() && process.env.VUE_APP_API_BASE_URL_NATIVE
    ? process.env.VUE_APP_API_BASE_URL_NATIVE
    : process.env.VUE_APP_API_BASE_URL

  return rewriteLoopbackForNative(fromEnv || '')
}

export function getApiUrl(path = '') {
  return getApiBaseUrl() + (process.env.VUE_APP_API_VERSION || '') + path
}

export default {
  getPlatform,
  isNativePlatform,
  rewriteLoopbackForNative,
  getApiBaseUrl,
  getApiUrl,
}
